export default "__VITE_ASSET__Db$cMLk8__"